
// Client-side rate limiting utilities
const RATE_LIMIT_KEY = 'proposal_generator_last_request';
const RATE_LIMIT_COOLDOWN = 10 * 1000; // 10 seconds

export const checkRateLimit = (): { isLimited: boolean; remainingTime: number } => {
  const lastRequest = localStorage.getItem(RATE_LIMIT_KEY);
  
  if (lastRequest) {
    const lastRequestTime = parseInt(lastRequest, 10);
    const now = Date.now();
    const elapsed = now - lastRequestTime;
    
    if (elapsed < RATE_LIMIT_COOLDOWN) {
      return { 
        isLimited: true, 
        remainingTime: RATE_LIMIT_COOLDOWN - elapsed 
      };
    }
  }
  
  // Not rate limited
  return { isLimited: false, remainingTime: 0 };
};

export const setLastRequestTime = (): void => {
  localStorage.setItem(RATE_LIMIT_KEY, Date.now().toString());
};
